export default "__VITE_ASSET__GNC7bN1O__"